import { db, type AddressState } from "@/db";

/** Cache only the server-owned marker, preserving the rest of the address state. */
export async function cacheSentToSuddleAt(
  udprn: number,
  sentToSuddleAt: AddressState["sent_to_suddle_at"],
) {
  if (sentToSuddleAt === undefined) return;
  try {
    await db.transaction("rw", [db.addressStates, db.addresses], async () => {
      const current = await db.addressStates.get(udprn);
      const prefix = current?.prefix ?? (await db.addresses.get(udprn))?.prefix;
      await db.addressStates.put({
        udprn, status: null, last_note_id: null, ...current,
        prefix, sent_to_suddle_at: sentToSuddleAt,
      });
    });
  } catch {
    // A cache failure must not fail a committed note or retry its upload.
    // The next normal offline refresh repairs this cache.
  }
}
